<template>
    <div>
      <section class="box-steps">
        <div class="container">
          <div class="row">
            <div class="col-lg-3">
              <a href="#" @click.prevent="manageTab(1)" :class="{ 'active': activeTab === 1 }">
                <div class="box-step step-1">
                  <div class="number"><i class="fa fa-shopping-cart"></i></div>
                  <div class="name">
                    Carro de Compras
                  </div>
                  <div class="step-indicator" v-if="activeTab === 1">
                    <i class="fa fa-chevron-down"></i>
                  </div>
                </div>
              </a>
            </div>

            <div class="col-lg-3">
              <div class="box-step step-4" :class="{ 'active': activeTab === 2 }">
                <div class="number"><i class="fa fa-check"></i></div>
                <div class="name">Finalizar Compra</div>
                <div class="step-indicator" v-if="activeTab === 2">
                  <i class="fa fa-chevron-down"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="micarrito">
        <div class="container">
          <div v-if="isLoading" class="loading-overlay">
            <div class="spinner"></div>
            <p>Cargando...</p>
          </div>

          <div class="row" v-if="((cart_items.length>0) || (activeTab>1))">
            <div class="col-lg-8" v-if="activeTab===1">
              <div class="box-producto-carrito" v-for="item in cart_items" :key="item.product.code">
                <div class="box-image">
                  <img :src="findImage(item.product)" :alt="item.product.description">
                </div>
                <div class="box-data">
                  <div class="product-header">
                    <h1>{{item.product.code}}</h1>
                    <button class="btn-remove" @click.prevent="removeFromCart(item)" title="Eliminar producto">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                  <h2>{{item.product.description}}</h2>
                  <div class="product-details">
                    <div class="box-cantidad">
                      <div class="lbl">Cantidad</div>
                      <div class="value">
                        <div class="quantity-input-group">
                          <button
                            class="quantity-btn"
                            @click="decreaseQuantity(item)"
                            :disabled="!canDecrease(item)"
                          >
                            <i class="fa fa-minus"></i>
                          </button>
                          <input
                            type="number"
                            class="quantity-input"
                            v-model.number="item.quantity"
                            @change="onQuantityInput(item)"
                            :min="rangeStock(item.product)[0]"
                            :max="rangeStock(item.product)[rangeStock(item.product).length-1]"
                            step="1"
                          >
                          <button
                            class="quantity-btn"
                            @click="increaseQuantity(item)"
                            :disabled="!canIncrease(item)"
                          >
                            <i class="fa fa-plus"></i>
                          </button>
                        </div>
                        <div class="stock-info" v-if="item.product.stock_available > 0">
                          <i class="fa fa-cubes"></i>
                          Stock disponible: {{item.product.stock_available}} unidades
                        </div>
                      </div>
                    </div>
                    <div class="price-details">
                      <div class="box-precio">
                        <div class="lbl">Precio Unitario</div>
                        <div class="price-display">
                          <span v-if="hasDiscount(item.product)" class="price-original">{{item.product.price | currency}}</span>
                          <span class="value" :class="{'price-discounted': hasDiscount(item.product)}">
                            {{getEffectivePrice(item.product) | currency}} + IVA
                          </span>
                          <span v-if="hasDiscount(item.product)" class="discount-badge-inline">-{{item.product.discount_percentage}}%</span>
                        </div>
                      </div>
                      <div class="box-precio total">
                        <div class="lbl">Precio Total</div>
                        <div class="price-display">
                          <span v-if="hasDiscount(item.product)" class="price-original">{{item.product.price * item.quantity | currency}}</span>
                          <span class="value" :class="{'price-discounted': hasDiscount(item.product)}">
                            {{getEffectivePrice(item.product) * item.quantity | currency}} + IVA
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-8" v-if="activeTab===2">
              <div class="shipping-section">
                <h2 class="title">Formas de <span>Envío</span></h2>
                <p class="copete">
                  Seleccioná una de las formas de envío disponibles <span>según los productos de tu pedido:</span>
                </p>

                <div class="box-content-options">
                  <div class="box-option">
                    <label class="option">
                      <input class="forma_envio" type="radio" v-model="form_shipment.forma_envio" value="RETIRO_SUCURSAL">
                      <div class="description">
                        <strong>
                          Retiro en Marta Roggiero Store: <span class="badge badge-success">GRATIS</span>
                        </strong>
                        <p>Independencia 160, Avellaneda, Buenos Aires, de Lunes a Sábados de 10:00 a 20:00.</p>
                      </div>
                    </label>
                  </div>

                  <div class="box-option">
                    <label class="option">
                      <input class="forma_envio" type="radio" v-model="form_shipment.forma_envio" value="CONVENIR">
                      <div class="description">
                        <strong>A convenir:</strong>
                        <p>Nos comunicaremos a la brevedad para convenir la forma de envio.</p>
                      </div>
                    </label>
                  </div>
                </div>

                <div class="observations-section">
                  <h3 class="title">Observaciones</h3>
                  <p class="copete">
                    Cualquier comentario u observación sobre su pedido puede hacerlo a continuación:
                  </p>
                  <div class="inputForm">
                    <textarea
                      id="envio_observacion"
                      v-model="form_shipment.envio_observacion"
                      class="form-control"
                      rows="4"
                      placeholder="Ingrese sus observaciones aquí..."
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4 sticky-header" v-if="activeTab<=3">
              <div class="box-resumen-compra">
                <h1>Tu Compra <i class="fa fa-shopping-cart pull-right"></i></h1>

                <div class="row" v-if="sucursales.length>0">
                  <div class="col-xs-12">
                    <div class="form-group branch-selector">
                      <label for="sucursal">Seleccionar Sucursal</label>
                      <div class="branch-options">
                        <div
                          v-for="(n,index) in sucursales"
                          :key="index"
                          class="branch-option"
                          :class="{ 'active': sucursal === n.COD_CLIENT }"
                          @click="sucursal = n.COD_CLIENT"
                        >
                          <div class="branch-info">
                            <i class="fa fa-building"></i>
                            <div class="branch-details">
                              <strong>{{n.DIR_COM}}</strong>
                              <span>{{n.LOCALIDAD}}, {{n.PROVINCIA}}</span>
                            </div>
                          </div>
                          <div class="branch-select">
                            <i class="fa fa-check-circle"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="order-summary">
                  <div class="row">
                    <div class="col-xs-6">
                      <div class="lbl">Subtotal</div>
                    </div>
                    <div class="col-xs-6">
                      <div class="value">{{cart_subtotal | currency}}</div>
                    </div>
                  </div>

                  <div class="row" v-if="discount_value>0">
                    <div class="col-xs-6">
                      <div class="lbl">Descuento</div>
                    </div>
                    <div class="col-xs-6">
                      <div class="value text-success">- {{discount_value | currency}}</div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xs-6">
                      <div class="lbl">IVA</div>
                    </div>
                    <div class="col-xs-6">
                      <div class="value">{{cart_total * 0.21 | currency}}</div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xs-6">
                      <div class="lbl">Costo de envío</div>
                    </div>
                    <div class="col-xs-6">
                      <div class="value">{{ shipmentCost }}</div>
                    </div>
                  </div>

                  <div class="spaceline"></div>

                  <div class="row total-row">
                    <div class="col-xs-6">
                      <div class="lbl">TOTAL</div>
                    </div>
                    <div class="col-xs-6">
                      <div class="value highlight">{{cart_total + (cart_total * 0.21) | currency}}</div>
                    </div>
                  </div>
                </div>

                <div class="action-buttons">
                  <router-link to="/" class="btn btn-outline-primary btn-block mb-3">
                    <i class="fa fa-arrow-left"></i> Elegir más productos
                  </router-link>

                  <button
                    class="btn btn-primary btn-block btn-lg"
                    v-if="(cart_total>=purchaseMin)"
                    @click="continueShopping"
                    :disabled="isPlacingOrder"
                  >
                    <span v-if="!isPlacingOrder">FINALIZAR COMPRA</span>
                    <span v-else>
                      <i class="fa fa-spinner fa-spin"></i> Procesando...
                    </span>
                  </button>
                  <div v-else class="alert alert-warning">
                    El mínimo es {{purchaseMin | currency}}, te faltan {{ parseFloat(purchaseMin - cart_total ) | currency}}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="((cart_items.length<=0)&&(activeTab<4))">
            <div class="col-lg-12">
              <div class="box-noproducts text-center">
                <h1>Su pedido ha sido generado correctamente.</h1>
                <router-link to="/" class="btn btn-primary btn-lg">CONTINUAR</router-link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
</template>

<script>
import Api from '@/Api'
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isLoading: false,
      isPlacingOrder: false,
      categories: [],
      sucursales: [],
      sucursal: null,
      activeTab: 1,
      maxTabs: 2,
      payment_type: 'CC',
      form_shipment: {
        envio_observacion: '',
        forma_envio: 'RETIRO_SUCURSAL',
        payment: 'CC'
      },
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'isLogged',
      'cart_total',
      'cart_subtotal',
      'discount_value',
      'cart_items',
      'purchaseMin',
      'shipment',
      'payment'
    ]),
    shipmentCost() {
      return this.form_shipment.forma_envio === 'RETIRO_SUCURSAL' ? 'Gratis' : 'A convenir';
    },
  },
  methods: {
    hasDiscount(product) {
      return product.enable_discount && product.discount_percentage > 0;
    },
    getEffectivePrice(product) {
      if (this.hasDiscount(product)) {
        return product.price * (1 - product.discount_percentage / 100);
      }
      return product.price;
    },
    findImage(product) {
      if (product.images)
      {
        return product.images[0].url;
      }
      return product.images || '/static/img/noimage.jpg';
    },
    manageTab(tab) {
      this.activeTab = tab;
      window.scrollTo(0, 0);
    },
    updateTabSelected(tab) {
      $(".box-step").removeClass('active');
      $(".box-step.step-"+tab).addClass('active');
    },
    async continueShopping() {
      if (this.isPlacingOrder) return;

      try {
        this.isPlacingOrder = true;

        const cartItems = this.cart_items.map(value => ({
          product_id: value.product.code,
          quantity: value.quantity
        }));

        const order = {
          comment: this.form_shipment.envio_observacion,
          sucursal: this.sucursal,
          products: cartItems
        };

        await this.$store.dispatch("processCartPurchase", { order });

        window.scrollTo(0, 0);
      } catch (err) {
        this.$swal({
          title: 'Error',
          text: err || 'Ocurrió un error al procesar su compra',
          type: 'error',
        });
      } finally {
        this.isPlacingOrder = false;
      }
    },
    rangeStock(product) {
      // Ensure all values are numbers and have sensible defaults
      const min = Number(product.product_purchase_min) > 0 ? Number(product.product_purchase_min) : 1;
      const max = Number(product.product_purchase_max) > 0 ? Number(product.product_purchase_max) : Number(product.STOCK) || 1;
      const step = Number(product.product_multiplier) > 0 ? Number(product.product_multiplier) : 1;

      // If min > max, return [min] (edge case)
      if (min > max) return [min];

      const result = [];
      for (let i = min; i <= max; i += step) {
        result.push(i);
      }
      // If max is not exactly on a step, but is greater than min, and divisible by step, include it
      if ((max - min) % step !== 0 && max > min && max <= Number(product.STOCK)) {
        if (!result.includes(max)) result.push(max);
      }
      return result;
    },
    async editQuantity(item) {
      try {
        await this.$store.dispatch("editCartQuantity", {
          product: item,
          quantity: item.quantity
        });
      } catch (err) {
        this.$swal({
          title: 'Error',
          text: 'No se pudo actualizar la cantidad',
          type: 'error',
        });
      }
    },
    async removeFromCart(item) {
      try {
        await this.$store.dispatch("removeFromCart", { item });

        if (this.cart_items.length <= 0) {
          $("nav.micarrito, .overlay-micarrito").removeClass("open");
          $("body").removeClass("lock");
        }
      } catch (err) {
        this.$swal({
          title: 'Error',
          text: 'No se pudo eliminar el producto',
          type: 'error',
        });
      }
    },
    async loadSucursales() {
      try {
        this.isLoading = true;
        const { data } = await Api().get('user/sucursales');

        if (data.status === 1) {
          this.sucursales = data.data;
          if (this.sucursales.length > 0) {
            this.sucursal = this.sucursales[0].COD_CLIENT;
          }
        }
      } catch (err) {
        this.$swal({
          title: 'Error',
          text: 'No se pudieron cargar las sucursales',
          type: 'error',
        });
      } finally {
        this.isLoading = false;
      }
    },
    decreaseQuantity(item) {
      const allowed = this.rangeStock(item.product);
      const idx = allowed.indexOf(item.quantity);
      if (idx > 0) {
        item.quantity = allowed[idx - 1];
        this.editQuantity(item);
      }
    },
    increaseQuantity(item) {
      const allowed = this.rangeStock(item.product);
      const idx = allowed.indexOf(item.quantity);
      if (idx < allowed.length - 1) {
        item.quantity = allowed[idx + 1];
        this.editQuantity(item);
      }
    },
    canDecrease(item) {
      const allowed = this.rangeStock(item.product);
      return allowed.indexOf(item.quantity) > 0;
    },
    canIncrease(item) {
      const allowed = this.rangeStock(item.product);
      return allowed.indexOf(item.quantity) < allowed.length - 1;
    },
    onQuantityInput(item) {
      const allowed = this.rangeStock(item.product);
      let val = Number(item.quantity);
      // Snap to closest allowed value
      let closest = allowed.reduce((prev, curr) => Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev);
      item.quantity = closest;
      this.editQuantity(item);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.updateTabSelected(1);
    this.loadSucursales();
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.box-step {
  position: relative;
  background: white;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  transition: all 0.3s ease;
  border: 2px solid #dee2e6;
  margin-bottom: 30px;
}

.box-step.active {
  border-color: #dd3f69;
  background: #fff5f7;
}

.box-step .number {
  width: 50px;
  height: 50px;
  background: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  font-size: 1.5rem;
  color: #666;
  transition: all 0.3s ease;
}

.box-step.active .number {
  background: #dd3f69;
  color: white;
}

.box-step .name {
  font-size: 1.1rem;
  color: #666;
  font-weight: 500;
  transition: all 0.3s ease;
}

.box-step.active .name {
  color: #dd3f69;
}

.step-indicator {
  position: absolute;
  bottom: -45px;
  left: 50%;
  transform: translateX(-50%);
  color: #dd3f69;
  font-size: 1.2rem;
  animation: bounce 1s infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateX(-50%) translateY(0); }
  50% { transform: translateX(-50%) translateY(-5px); }
}

.sticky-header {
  position: sticky;
  top: 0;
  background: white;
  padding: 1rem 0;
  z-index: 10;
  margin-bottom: 1rem;
}

.quantity-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f8f9fa;
  padding: 5px;
  border-radius: 8px;
  width: fit-content;
}
.quantity-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: white;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #dd3f69;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}
.quantity-btn:hover:not(:disabled) {
  background: #dd3f69;
  color: white;
}
.quantity-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.quantity-input {
  width: 60px;
  height: 32px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  text-align: center;
  font-size: 1rem;
  color: #333;
  background: white;
  appearance: textfield;
  -moz-appearance: textfield;
}
.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.box-producto-carrito {
  position: relative;
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #dee2e6;
  border-radius: 12px;
  transition: all 0.3s ease;
  background: white;
  display: flex;
  gap: 20px;
}

.box-producto-carrito:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transform: translateY(-2px);
}

.box-image {
  flex: 0 0 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  background: #f8f9fa;
}

.box-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.box-data {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.product-header h1 {
  font-size: 1.1rem;
  color: #666;
  margin: 0;
}

.product-header h2 {
  font-size: 1.2rem;
  color: #333;
  margin: 5px 0;
  font-weight: 500;
}

.product-details {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 10px;
}

.price-details {
  display: flex;
  gap: 20px;
}

.box-precio {
  flex: 1;
}

.box-precio.total {
  text-align: right;
}

.box-precio .lbl {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 5px;
}

.box-precio .value {
  font-size: 1.1rem;
  color: #333;
  font-weight: 500;
}

.box-precio.total .value {
  color: #dd3f69;
  font-weight: 600;
}

.price-display {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.price-original {
  font-size: 0.85em;
  color: #999;
  text-decoration: line-through;
  font-weight: 400;
}

.price-discounted {
  color: #e74c3c !important;
  font-weight: 700 !important;
}

.discount-badge-inline {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.75em;
  font-weight: bold;
  display: inline-block;
  width: fit-content;
}

.btn-remove {
  position: static;
  padding: 8px;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #dee2e6;
  color: #dc3545;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-remove:hover {
  background: #dc3545;
  color: white;
  border-color: #dc3545;
}

.shipping-section {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.box-option {
  margin-bottom: 15px;
  padding: 15px;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.box-option:hover {
  border-color: #007bff;
}

.badge-success {
  background-color: #28a745;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
}

.order-summary {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin: 20px 0;
}

.total-row {
  font-size: 1.2em;
  font-weight: bold;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 2px solid #dee2e6;
}

.action-buttons {
  margin-top: 20px;
}

.btn {
  padding: 10px 20px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.btn-primary {
  background-color: #DB5378;
  border-color: #c44a6b;
}

.btn-primary:hover {
  background-color: #dd3f69;
  border-color: #DB5378;
}

.btn-outline-primary {
  color: #dd3f69;
  border-color: #dd3f69;
}

.btn-outline-primary:hover {
  background-color: #dd3f69;
  color: white;
}

.alert {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}

.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: #e67f9a;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}

.text-success {
  color: #28a745 !important;
}

.highlight {
  color: #007bff;
  font-weight: bold;
}

.branch-selector {
  margin-bottom: 30px;
}

.branch-selector label {
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 15px;
  display: block;
}

.branch-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.branch-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border: 2px solid #dee2e6;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.branch-option:hover {
  border-color: #dd3f69;
  background: #fff5f7;
}

.branch-option.active {
  border-color: #dd3f69;
  background: #fff5f7;
}

.branch-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.branch-info i {
  font-size: 1.5rem;
  color: #dd3f69;
}

.branch-details {
  display: flex;
  flex-direction: column;
}

.branch-details strong {
  font-size: 1rem;
  color: #333;
  margin-bottom: 3px;
}

.branch-details span {
  font-size: 0.9rem;
  color: #666;
}

.branch-select i {
  color: #dd3f69;
  font-size: 1.2rem;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.branch-option.active .branch-select i {
  opacity: 1;
}

@media (max-width: 768px) {
  .box-producto-carrito {
    flex-direction: column;
  }

  .box-image {
    width: 100%;
    height: 200px;
  }

  .price-details {
    flex-direction: column;
    gap: 10px;
  }

  .box-precio.total {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CarritoPage.vue